const measurementPointCoord =
{
  x: '2010',
  y: '2011'
}

export default { measurementPointCoord }
